import React from "react";
import Datetime from "react-datetime";
import TextField from "components/common/TextField/TextField";
import { ICnicInfo } from "interfaces/Index";
import {
  user,
  OWNER_VERIFICATION_STATUS,
  CUSTOMER_CHANNEL,
} from "../../../../config/constants";

const CnicInfo = (props: ICnicInfo) => {
  const {
    userId,
    name,
    phoneNumber,
    userType,
    expiryDate,
    nationalId,
    ownerStatus,
    dateOfBirth,
    customerChannel,
  } = props;

  return (
    <>
      {userId && !ownerStatus && (
        <TextField
          id="userid"
          label="User ID"
          placeholder="User ID"
          value={userId}
          type={"text"}
          disabled={true}
        />
      )}

      {name && !ownerStatus && (
        <TextField
          id="name"
          label="Name"
          placeholder="Name"
          value={name}
          type={"text"}
          disabled={true}
        />
      )}

      <TextField
        id="cnic"
        label="CNIC"
        placeholder="CNIC"
        value={nationalId}
        type={"text"}
        disabled={true}
      />

      {phoneNumber && (
        <TextField
          id="phonenumber"
          label="Phone Number"
          placeholder="Phone Number"
          value={phoneNumber}
          type={"text"}
          disabled={true}
        />
      )}

      {(ownerStatus === OWNER_VERIFICATION_STATUS.PENDING_VERIFICATION ||
        customerChannel === CUSTOMER_CHANNEL.GENERAL_TRADE) && (
        <section
          className="form-group search-container"
          id="expiry-date-container"
        >
          <label className="block text-uppercase label">Expiry Date</label>
          <Datetime
            value={expiryDate || undefined}
            onChange={(event) =>
              props.handleDateChange(userType + "_EXPIRY", event)
            }
            inputProps={{ placeholder: "Select expiry date" }}
            closeOnSelect={true}
            closeOnClickOutside={true}
            timeFormat={false}
          />
        </section>
      )}
      {(ownerStatus === OWNER_VERIFICATION_STATUS.PENDING_VERIFICATION ||
        customerChannel === CUSTOMER_CHANNEL.GENERAL_TRADE) && (
        <section
          className="form-group search-container"
          id="dob-date-container"
        >
          <label className="block text-uppercase label">Date Of Birth</label>
          <Datetime
            value={dateOfBirth || undefined}
            onChange={(event) =>
              props.handleDateChange(props.userType + "_DOB", event)
            }
            inputProps={{ placeholder: "Select date of birth" }}
            closeOnSelect={true}
            closeOnClickOutside={true}
            timeFormat={false}
          />
        </section>
      )}
    </>
  );
};

export default CnicInfo;
